import React from 'react';

import { formatMessage } from '@explorer/helpers';
import MuiChip, { ChipProps as MuiChipProps } from '@mui/material/Chip';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Chip = withCoreProps<ChipProps>(
  ({ label, className, ...props }: React.PropsWithChildren<ChipProps>) => {
    // const classes = useStyles({});
    const intl = useIntl();
    const clsxClass = clsx(className);

    return (
      <MuiChip
        {...props}
        label={formatMessage(intl, label)}
        className={clsxClass}
      />
    );
  },
);

export type ChipProps = Omit<MuiChipProps, 'label'> &
  CoreProps & { label: IntlLabel };
